<template>
    <div class="pagination" v-if="total > 7" :class="total > 500?'hidePage':''">
        <el-pagination
          background
          layout="prev, pager, next"
          @prev-click="getList"
          @next-click="getList"
          @current-change="getList"
          hide-on-single-page
          :pager-count="5"
          :page-size="pageSize?pageSize:10"
          :total="total">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        props: {
            total: Number,
            pageSize: Number
        },
        methods: {
            getList(page) {
                let top = document.documentElement.scrollTop || document.body.scrollTop;
                // 实现滚动效果 
                const timeTop = setInterval(() => {
                    document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                    if (top <= 0) {
                    clearInterval(timeTop);
                    }
                }, 10);
                this.$emit('getList', page)
            }
        }
    }
</script>

<style lang="scss" scoped>
.pagination {
  background: white;
  margin-top: 10px;
  text-align: right;
  padding: 10px;
}
</style>

<style lang="scss">
    .hidePage {
        .number:last-child {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/page/index.vue